
import { useState } from 'react';
import { User } from '@/types';
import { Card, CardContent } from '@/components/ui/card';
import UsersTable from './dashboard/UsersTable';
import AddUserSheet from './AddUserSheet';
import { useUserManagement } from './users/useUserManagement';
import UserManagementHeader from './users/UserManagementHeader';

export default function UserManagement() {
  const [isAddUserSheetOpen, setIsAddUserSheetOpen] = useState(false);

  const { 
    users, 
    isLoading, 
    fetchUsers, 
    handleDeleteUser, 
    handleToggleUserStatus, 
    handleToggleUserRole, 
    handleAddUser 
  } = useUserManagement();

  const handleAddUserSheetOpen = () => {
    setIsAddUserSheetOpen(true);
  };

  if (isLoading) {
    return <div className="py-4 text-center">Chargement...</div>;
  }

  return (
    <Card>
      <UserManagementHeader 
        onRefresh={fetchUsers}
        onAddUser={handleAddUserSheetOpen}
      />
      <CardContent>
        <UsersTable
          users={users}
          onDeleteUser={handleDeleteUser}
          onToggleUserStatus={handleToggleUserStatus}
          onToggleUserRole={handleToggleUserRole}
        />
      </CardContent>

      <AddUserSheet
        isOpen={isAddUserSheetOpen}
        onClose={() => setIsAddUserSheetOpen(false)}
        onAdd={handleAddUser}
      />
    </Card>
  );
}
